import { render, staticRenderFns } from "./EpisodesList.vue?vue&type=template&id=320897a0&"
import script from "./EpisodesList.vue?vue&type=script&lang=js&"
export * from "./EpisodesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports